import { useCallback } from 'react';

import { LenderSectionRowValidation } from '@styles/ContactManager/DealCalculator/LenderSectionStyles';
import { creditRuleColorCSS } from '../../../../interfaces';

export enum CreditRulesTypes {
  TimeSinceBankruptcy = 'Time Since Bankruptcy (Months)',
  TotalNumberOfAutoPayments = 'Total Number of Auto Payments (Months)',
  CurrentlyPastDueOnAutoLoan = 'Currently Past Due on an Auto Loan',
  BankruptcyFiled = 'Bankruptcy Filed',
  TotalTimeOnBureau = 'Total Time on Bureau (Months)',
  TimeSinceAutoChargeOff = 'Time Since Auto Charge-off (Months)',
  IsCitizen = 'Is Citizen',
}

export interface ILenderCreditRules {
  creditRuleCellType: string;
  creditRuleResults: string;
  creditRuleType: string;
}

interface ILenderCreditRulesProps {
  lenderCreditRules?: ILenderCreditRules[];
}

const LenderCreditRules = ({ lenderCreditRules = [] }: ILenderCreditRulesProps) => {

  const getCellType = useCallback((ruleType: string) => {
    const cellType = lenderCreditRules.find((rule) => rule.creditRuleType === ruleType)?.creditRuleCellType;
    return cellType;
  }, [lenderCreditRules]);

  return (
    <>
      {Object.keys(CreditRulesTypes).map((ruleType, i) => (
        <LenderSectionRowValidation
          key={i}
          style={{
            fontWeight: 'bold',
            ...creditRuleColorCSS[getCellType(ruleType) as keyof typeof creditRuleColorCSS]
          }}
        >
          {lenderCreditRules.find((rule: ILenderCreditRules) =>
            rule.creditRuleType === ruleType)?.creditRuleResults || 'N/A'}
        </LenderSectionRowValidation>
      ))}
    </>
  );
};

export default LenderCreditRules;
